import axios from "axios";

class utilityServices {
    getClientLocationAndCurrency() {
        return axios
            .get('https://ipapi.co/json/',{ crossdomain: true })
    }
}

const UtilityServices = new utilityServices();
export default UtilityServices;